import { SummaryHeader, getResourceName } from 'features/resources'
import {
  useUserDetailsContext
} from 'features/users'
import React from 'react'

function Header() {
  const { user } = useUserDetailsContext()

  return (
    <div>
      <SummaryHeader
        actions={
          <div className='flex gap-4'>
            {/* <SwitchBox
              checked={getUserStatus(user) === 'Active'}
              label={getUserStatus(user)}
              onChange={handleUserActiveStatusChange}
              variant='primary'
            /> */}
            {/* <Button onClick={() => setShowOnboardingModal(true)} size='md' variant='grayBlue'>
              Onboard User
            </Button>
            <Button onClick={() => setShowDeleteUserModal(true)} size='md' variant='grayRed'>
              Delete User
            </Button> */}
          </div>
        }
        breadCrumbsItems={[
          {
            label: 'Users',
            link: '/admin/users'
          },
          {
            label: getResourceName(user)
          }
        ]}
        rsrcName={getResourceName(user)}
      />
      {/* {showOnboardingModal && (
        <OnboardingLinkModal user={user} onClose={() => setShowOnboardingModal(false)} />
      )}
      {showDeleteUserModal && (
        <DeleteUserModal
          user={user}
          onCancel={() => setShowDeleteUserModal(false)}
          onSuccess={handleDeleteSuccess}
        />
      )} */}
      {/* <LoadingFeedback
        loading={isStatusChanging}
        message={`${getUserStatus(user) === 'Active' ? 'Deactivating' : 'Activating'} User`}
        caption='Please wait..'
      /> */}
    </div>
  )
}

export { Header }
